import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Menu, X, Play } from 'lucide-react';
import { ImageSlider } from './components/ImageSlider';
function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [isTeamExpanded, setIsTeamExpanded] = useState(false);
  const [isEventImagesExpanded, setIsEventImagesExpanded] = useState(false);
  const eventImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k443DHwXjcGVMkoyTVB7hE/ams-screening1.jpg',
    alt: 'Speaker at Amsterdam screening event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hQ9K3AK4SchrNqj4VUJX67/ams-screening2.jpg',
    alt: 'Panel discussion at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mk12QnRVRev2b91HasdoT3/ams-screening6.jpg',
    alt: 'Attendees in conversation at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jHyugobVEDFAvxHNtzQbuq/ams-screening7.jpg',
    alt: 'Panel discussion with female speaker at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e34uFhXF9zvbi39bpDpswG/ams-screening8.jpg',
    alt: 'Moderator introducing speakers at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sp2GD1Y7NRmrPRNFN23LjE/ams-screening4.jpg',
    alt: 'Producers in conversation at Amsterdam screening event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5FdNn1yQminT3cNfV3MjEf/ams-screening5.jpg',
    alt: 'Attendees in discussion at Amsterdam screening'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6J5NThdpuPd1FKAR2uMM17/ams-screening3.jpg',
    alt: 'Panel discussion with speakers at Amsterdam screening'
  }];
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const sections = ['hero', 'about', 'our-mission', 'trailer', 'watch', 'in-the-media', 'team', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <Router data-id="element-0" data-mp="3lkr5lt3ovktw">
      <div className="relative w-full min-h-screen bg-black font-sans" data-id="element-1" data-mp="3ljxukfxp695y">
        <div className="mx-auto max-w-[1920px] relative" data-id="element-2" data-mp="2xuwubfz0q4br">
          <section id="hero" className="relative w-full overflow-hidden" style={{
          aspectRatio: '1920/1080'
        }} data-id="element-3" data-mp="2xtbzdp8skjdd">
            <div className="absolute inset-0 flex justify-end" data-id="element-4" data-mp="18cq57il9mcrv">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/32d35855-03bc-42fa-88d9-49f33f2322a4/EEM-hero-desktop-1920.jpg" alt="Everything Else Matters Documentary" className="h-full w-full object-cover object-center sm:object-right" data-id="element-5" data-mp="1d47x7h5b930p" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/30 z-20" data-id="element-6" data-mp="1r4seg8vkuqs3" />
            <div className="absolute inset-0 flex flex-col justify-center px-4 sm:px-8 text-white text-left z-30 pt-12 sm:pt-0" data-id="element-7" data-mp="1w2kfpti43p8y">
              <div className="max-w-full" data-id="element-8" data-mp="1m5654aivduok">
                <h1 className="font-['Bebas_Neue'] text-4xl xs:text-3xl sm:text-5xl md:text-8xl lg:text-9xl font-normal tracking-wide mb-2 xs:mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-white to-blue-400 leading-[0.9]" data-id="element-9" data-mp="1m3uxfzmb02s6">
                  EVERYTHING
                  <br data-id="element-10" data-mp="qxf7hpbdb1hr" />
                  ELSE
                  <br data-id="element-11" data-mp="qz8g3a5jjvse" />
                  MATTERS
                </h1>
                <p className="font-sans text-sm xs:text-base sm:text-xl md:text-2xl mb-2 xs:mb-4 font-light tracking-wide text-purple-500" data-id="element-12" data-mp="m5nfrbgh6pq1">
                  Deconstructing Psychedelic Experience
                </p>
                <p className="font-sans text-xs xs:text-sm sm:text-lg md:text-xl font-light tracking-widest text-purple-500 mb-4 xs:mb-8" data-id="element-13" data-mp="c9u37s2raw89">
                  A Film by Antoine Bellanger
                </p>
                <div className="flex flex-col items-start mt-1 xs:mt-2" data-id="element-14" data-mp="14xpxyr8rme2e">
                  <a href="#trailer" className="inline-flex items-center px-4 xs:px-5 py-2 xs:py-2.5 bg-purple-500/20 hover:bg-purple-500/30 border border-purple-500/50 rounded-lg text-white transition-all duration-300 hover:scale-105 backdrop-blur-sm group text-xs xs:text-sm sm:text-base" onClick={e => {
                  e.preventDefault();
                  document.getElementById('trailer')?.scrollIntoView({
                    behavior: 'smooth'
                  });
                  setTimeout(() => {
                    const iframe = document.querySelector('#trailer iframe');
                    if (iframe) {
                      const src = iframe.getAttribute('src');
                      if (src) {
                        iframe.setAttribute('src', `${src}?autoplay=1`);
                      }
                    }
                  }, 1000);
                }} data-id="element-15" data-mp="zwirqwm9tmxu">
                    <Play className="w-3 h-3 xs:w-4 xs:h-4 mr-1 xs:mr-2 group-hover:scale-110 transition-transform" data-id="element-16" data-mp="2nwe4ppde76n3" />
                    Watch the Trailer
                  </a>
                </div>
              </div>
            </div>
          </section>
          <nav className="md:fixed relative left-0 right-0 z-50 font-display md:top-0" data-id="element-17" data-mp="yg4zc2y4ydtb">
            <div className="max-w-[1920px] mx-auto" data-id="element-18" data-mp="21rambqoc5eyo">
              <div className="backdrop-blur-lg bg-black/80 border-b border-purple-500/20" data-id="element-19" data-mp="21ru85ih3wnhz">
                <div className="max-w-7xl mx-auto px-6" data-id="element-20" data-mp="1wu263vmqzl02">
                  <div className="flex justify-between items-center h-20" data-id="element-21" data-mp="2ass217xtzemu">
                    <div className="text-xl font-bold" data-id="element-22" data-mp="25t5oexe3bwdi">
                      <a href="#hero" className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400 hover:scale-105 transition-transform" data-id="element-23" data-mp="25se109und4yb">
                        EEM
                      </a>
                    </div>
                    <div className="hidden md:flex items-center gap-7 lg:gap-10" data-id="element-24" data-mp="2thynh2q0ekcc">
                      {['About', 'Our Mission', 'Trailer', 'Watch', 'In the Media', 'Team', 'Contact'].map(item => {
                      const sectionId = item.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
                      return <a key={item} href={`#${sectionId}`} className={`text-lg tracking-wide transition-all duration-300 ${activeSection === sectionId ? 'text-purple-400 scale-105' : 'text-white/90 hover:text-purple-300'}`} data-id="element-25" data-mp="387jjqpkdhg5l">
                            {item}
                          </a>;
                    })}
                    </div>
                    <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-26" data-mp="2uek3glcrnhwz">
                      {isMobileMenuOpen ? <X size={24} data-id="element-27" data-mp="2kf31of0mxo6a" /> : <Menu size={24} data-id="element-28" data-mp="2khz34dboyuzh" />}
                    </button>
                  </div>
                </div>
              </div>
              {isMobileMenuOpen && <div className="md:hidden py-6 backdrop-blur-lg bg-black/80 border-b border-purple-500/20" data-id="element-29" data-mp="2vwtwk4p71fa4">
                  <div className="flex flex-col space-y-6 px-6" data-id="element-30" data-mp="2qvcwucig3yv4">
                    {['About', 'Our Mission', 'Trailer', 'Watch', 'In the Media', 'Team', 'Contact'].map(item => {
                  const sectionId = item.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
                  return <a key={item} href={`#${sectionId}`} className={`text-lg tracking-wide transition-all duration-300 ${activeSection === sectionId ? 'text-purple-400' : 'text-white/90 hover:text-purple-300'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-31" data-mp="1y7h2vfk9gl21">
                          {item}
                        </a>;
                })}
                  </div>
                </div>}
            </div>
          </nav>
          <section id="about" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden pt-20" data-id="element-32" data-mp="3m6t7njbjauqg">
            <div className="absolute inset-0" data-id="element-33" data-mp="3r31iikip81rt">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/d6901fa4-135d-4cb8-89a1-c38f77490516/EEM-2nd-screen-1920.jpg" alt="Second screen background" className="w-full h-full object-cover" data-id="element-34" data-mp="3w3fs46zy7jry" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-35" data-mp="38e4nufje3792" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-36" data-mp="2f6lozbq8r2wf">
              <div className="max-w-3xl" data-id="element-37" data-mp="2k56rxiwvo0ok">
                <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-300 to-purple-400" data-id="element-38" data-mp="2k8az8p5n3cjg">
                  About
                </h2>
                <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-39" data-mp="2u21p9yhezv19">
                  <div className="space-y-6" data-id="element-40" data-mp="1wigrgm06ge62">
                    <div className="mb-8" data-id="element-41" data-mp="21f75l3sf8zou">
                      <p className="font-display text-3xl text-purple-300 mb-2" data-id="element-42" data-mp="21g8fh4xpbg4z">
                        Everything Else Matters: Deconstructing Psychedelic
                        Experience
                      </p>
                      <p className="text-lg text-purple-200" data-id="element-43" data-mp="2b7mp45jd9wbu">
                        Feature Documentary Film, 61 minutes
                      </p>
                    </div>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-44" data-mp="1ino451e1ptox">
                      <i data-id="element-45" data-mp="3vzs9xsgc8cvo">Everything Else Matters</i> is a non-profit documentary
                      project created to deepen public understanding of
                      psychedelic experiences.
                    </p>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-46" data-mp="3mxj2xcka31n1">
                      Produced in collaboration with the OPEN Foundation and the
                      Improbability Foundation, the film brings together leading
                      researchers, clinicians, and practitioners to examine the
                      science of set, setting, and the inner mechanisms of these
                      journeys. Our mission is to make complex knowledge
                      accessible, promote safer and more beneficial practices,
                      and support an informed, responsible conversation about
                      the therapeutic potential of psychedelics.
                    </p>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-47" data-mp="2pbtyhadrc7nv">
                      Improbability Foundation is a charitable foundation
                      dedicated to advancing human understanding of the brain and
                      mind. We support scientific, educational, and cultural
                      projects that explore consciousness, neuroscience, and the
                      potential of the human experience — including through film,
                      research, and interdisciplinary collaboration.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="our-mission" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-48" data-mp="2pmf8iccl8qak">
            <div className="absolute inset-0" data-id="element-49" data-mp="3hctgxt1u1aeu">
              <img src="https://cdn.magicpatterns.com/uploads/aD1584evrsQ6Zpgp6vDyw3/EEM-packshot-8.jpg" alt="Stone country house beneath a cloudy sky" className="w-full h-full object-cover" data-id="element-50" data-mp="3hc0bcvem0qya" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/10" data-id="element-51" data-mp="15pq08msxkppo" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-52" data-mp="1kem7wir2s0pr">
              <div className="max-w-3xl" data-id="element-53" data-mp="1ffj93g1ouqq8">
                <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-300 to-purple-400" data-id="element-54" data-mp="1ffrrfngkyo8t">
                  Our Mission
                </h2>
                <div className="backdrop-blur-sm bg-black/30 p-6 rounded-lg" data-id="element-55" data-mp="msf3b8uru8de">
                  <div className="space-y-6" data-id="element-56" data-mp="11omn4829p7s5">
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-57" data-mp="worvg2ao4e61">
                      Our purpose is to inspire, promote, and support scientific,
                      educational, arts, and cultural projects that advance our
                      understanding of the human brain and accelerate its
                      development.
                    </p>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-58" data-mp="hoo0gu94x0gs">
                      We believe that meaningful progress comes from combining
                      modern neuroscience with evolutionary, ethnocultural, and
                      artistic perspectives. By bridging these disciplines, we
                      aim to reveal insights from the past, make sense of the
                      present, and open new pathways for exploring — and
                      expanding — the potential of the human mind.
                    </p>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-59" data-mp="1aaz2888h97f6">
                      Our work focuses particularly on projects that are often
                      overlooked because of their interdisciplinary nature,
                      uncertain timelines, or unconventional approaches. We
                      support initiatives that push the boundaries of how we
                      understand consciousness, perception, healing, and human
                      potential.
                    </p>
                    <p className="text-white/90 text-lg leading-relaxed" data-id="element-60" data-mp="1tf2gdeje3e7t">
                      One of our recent projects is the documentary film{' '}
                      <i data-id="element-61" data-mp="1oiu54c8bc55x">Everything Else Matters</i>. The film brings together
                      leading researchers, psychiatrists, and practitioners to
                      examine how psychedelic experiences can be approached more
                      safely and beneficially — and when they should be avoided.
                      It serves as an educational resource aligned with our
                      broader mission to deepen public and scientific
                      understanding of the mind.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="trailer" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-62" data-mp="2v57iwvta8bbn">
            <div className="absolute inset-0" data-id="element-63" data-mp="y70k0ec8oi0a">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/c4c40fec-51a6-4fcc-a14a-71e4e382ded4/EEM-4th-screen-1920.jpg" alt="Third screen background" className="w-full h-full object-cover" data-id="element-64" data-mp="y5p4jh9flltc" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-65" data-mp="agecco65czqt" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-66" data-mp="fi3m80hmv7db">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-67" data-mp="kjp1fqzaghp">
                Trailer
              </h2>
              <div className="aspect-video w-full max-w-4xl mx-auto rounded-lg overflow-hidden shadow-2xl" data-id="element-68" data-mp="1uykmpxaskxg7">
                <iframe src="https://player.vimeo.com/video/1066137162" width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-69" data-mp="1zvu891v28oyr"></iframe>
              </div>
            </div>
          </section>
          <section id="watch" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-70" data-mp="3pc6myev646st">
            <div className="absolute inset-0" data-id="element-71" data-mp="2yoi2i7k961y">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/73495e13-8051-4657-b489-8adaee858f21/EEM-5th-screen-1920.jpg" alt="Watch section background" className="w-full h-full object-cover" data-id="element-72" data-mp="2zzlui10adt2" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-73" data-mp="2ipaznwyizpx8" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-74" data-mp="1rwsfy27x4yeb">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-75" data-mp="1rupt1r22bldt">
                Watch
              </h2>
              
              <div className="backdrop-blur-sm bg-black/20 p-8 rounded-lg max-w-3xl" data-id="element-76" data-mp="26loywubijvtp">
                <div className="space-y-8" data-id="element-77" data-mp="26nrppgkhpszh">
                 
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-78" data-mp="18z82rseino9j">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-79" data-mp="1dwhq92ichpuq">
                      <a href="https://www.youtube.com/watch?v=Gueajh2wfkY&t=369s" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-80" data-mp="1dz3yz5gz2bej">
                        Everything Else Matters YouTube Channel
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-81" data-mp="2zcgp9b5wdq94">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-82" data-mp="dwxpt5dvkcy0">
                      Watch from anywhere
                    </p>
                  </div>
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-83" data-mp="8xl4wq6kdfy2">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-84" data-mp="3z9uoeccx3fb">
                      <a href="https://www.gaia.com/video/everything-else-matters" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-85" data-mp="3wos1n48ijgi">
                        Gaia - Global
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-86" data-mp="1pbuj4rh3dob6">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-87" data-mp="2c96sj02ucm1c">
                      Stream worldwide on the Gaia platform
                    </p>
                  </div>
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-88" data-mp="22fydxumauoc1">
                    <p className="text-xl md:text-2xl mb-2" data-id="element-89" data-mp="1xj7zfbq580sq">
                      <a href="https://amazon.com/Everything-Else-Matters-Antoine-Bellanger/dp/B0FC6BXR94" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors flex items-center" data-id="element-90" data-mp="1xglpx6jozb7v">
                        Amazon Prime Video - US/UK
                        <span className="ml-2 text-green-400 text-sm bg-green-400/10 px-2 py-0.5 rounded" data-id="element-91" data-mp="3dwppgn9eldpl">
                          Available Now
                        </span>
                      </a>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-92" data-mp="3hff41jkt6kvo">
                      Stream in the United States and United Kingdom
                    </p>
                  </div>
                 
                  <div className="border-b border-purple-400/30 pb-6" data-id="element-93" data-mp="3q6ffe9h11e58">
                    <p className="text-xl md:text-2xl mb-2 text-purple-300 flex items-center" data-id="element-94" data-mp="3q9a0823yd0z6">
                      Spirit SVOD Platform - Netherlands/Belgium
                      <span className="ml-2 text-amber-400 text-sm bg-amber-400/10 px-2 py-0.5 rounded" data-id="element-95" data-mp="2yh2qllmv6oua">
                        Coming Soon
                      </span>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-96" data-mp="37fo95gsc63v2">
                      Available soon for streaming in the Netherlands and
                      Belgium
                    </p>
                  </div>
                  <div className="pb-2" data-id="element-97" data-mp="mpp35cuuq4v3">
                    <p className="text-xl md:text-2xl mb-2 text-purple-300 flex items-center" data-id="element-98" data-mp="rpbfzl6rpj3d">
                      HOT VOD Platform - Israel
                      <span className="ml-2 text-amber-400 text-sm bg-amber-400/10 px-2 py-0.5 rounded" data-id="element-99" data-mp="1zuy8sau130l">
                        Coming Soon
                      </span>
                    </p>
                    <p className="text-white/70 text-sm" data-id="element-100" data-mp="byarb0tf6mcq">
                      Available soon for streaming in Israel
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="in-the-media" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-101" data-mp="3fdy7lb3f1303">
            <div className="absolute inset-0" data-id="element-102" data-mp="3p6nh40feo6ss">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1qnMecJidvSNgS7q5DLspH/EEM-3rd-screen-1920.jpg" alt="Media section background" className="w-full h-full object-cover" data-id="element-103" data-mp="3kf5k1ngi6qd3" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-104" data-mp="2rpykqm985wqs" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-105" data-mp="176cqs9vv9yoh">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-106" data-mp="1c0gvsnlknwmx">
                In the Media
              </h2>
              <div className="flex flex-col lg:flex-row gap-12" data-id="element-107" data-mp="129m7ldormmyu">
                <div className="lg:w-1/2" data-id="element-108" data-mp="1pzyovf5whw23">
                  <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-109" data-mp="1pwuge5leke5m">
                    <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-110" data-mp="1ux8n9kb9pi22">
                      Events
                    </h3>
                    <div className="space-y-6" data-id="element-111" data-mp="1kzkh7y87oo4l">
                      <div className="border-l-2 border-purple-400 pl-6 mb-6" data-id="element-112" data-mp="1ky9d1xautecy">
                        <p className="text-white/90 text-lg mb-2" data-id="element-113" data-mp="5i0ptthqcvls">
                          <span className="text-purple-200 font-medium" data-id="element-114" data-mp="9kfcypsfmhiv">
                            11 June 2025
                          </span>{' '}
                          - Amsterdam screening at LAB111
                        </p>
                        <p className="text-white/90 mb-4" data-id="element-115" data-mp="l0bjssafa0ee">
                          Introduction by Joost Breeksema and Dmitry Repin.
                          Everything Else Matters documentary screening followed
                          by a panel discussion on the state of psychedelic
                          therapy.
                        </p>
                        <ImageSlider images={eventImages} data-id="element-116" data-mp="13rl3fudwq5jp" />
                      </div>
                    </div>
                  </div>
                  <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg mt-12" data-id="element-117" data-mp="yrgow9wk7kw4">
                    <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-118" data-mp="uroc1l04usky">
                      Music & Video
                    </h3>
                    <div className="space-y-6" data-id="element-119" data-mp="3jgmjgzk5467m">
                      <div className="border-l-2 border-purple-400 pl-6 mb-6" data-id="element-120" data-mp="3fgvun1e6c05q">
                        <p className="text-white/90 text-lg mb-4" data-id="element-121" data-mp="1uzcz9xg1b3jr">
                          "Run Little Baby" song by{' '}
                          <a href="https://www.youtube.com/@sfor7music" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-122" data-mp="1z1q48jmyixfh">
                            S for 7
                          </a>
                        </p>
                        <div className="aspect-video w-full rounded-lg overflow-hidden shadow-lg mb-4" data-id="element-123" data-mp="2incqszl66xze">
                          <iframe src="https://www.youtube.com/embed/F1mhC-GiL4s" width="100%" height="100%" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-124" data-mp="2mqsgtd2qi034"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:w-1/2" data-id="element-125" data-mp="29ku02tkjchv3">
                  <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-126" data-mp="24nkddloj6kay">
                    <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-127" data-mp="2jkum4n9shc2z">
                      Reviews
                    </h3>
                    <div className="space-y-6" data-id="element-128" data-mp="2el85s4ynzfpy">
                      <blockquote className="border-l-2 border-purple-400 pl-6" data-id="element-129" data-mp="2sdelxr1thmpe">
                        <p className="text-white/90 text-lg italic mb-6" data-id="element-130" data-mp="2sf908mil2gki">
                          "Everything Else Matters gives a rich picture of the
                          state of the art of current research in psychedelics.
                          The latest scientific insights and age-old ceremonial
                          wisdom are brought together and aligned with
                          experiential accounts and rich visualizations. The
                          film gives profound insight into the potential
                          benefits and possible dangers of psychedelics, all
                          depending on set, setting and dosage."
                        </p>
                        <footer className="text-purple-200" data-id="element-131" data-mp="3c114s8stezyv">
                          <p className="font-medium" data-id="element-132" data-mp="2y68golyv0bgo">Patricia Pisters</p>
                          <p className="text-sm text-purple-200/80" data-id="element-133" data-mp="32yrsbddzkwiu">
                            Professor of Film Studies, University of Amsterdam
                          </p>
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="team" className={`min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden transition-all duration-500 ${isTeamExpanded ? 'h-auto' : 'h-screen'}`} data-id="element-134" data-mp="2jaj1p7s3cylg">
            <div className="absolute inset-0" data-id="element-135" data-mp="2uqp37b62nct0">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/ffc0661c-0f7e-4689-888d-30d00dbed792/EEM-7th-screen-1920.jpg" alt="Team section background" className="w-full h-full object-cover" data-id="element-136" data-mp="2uovrvikik4eo" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-137" data-mp="2gsidiiba0j4f" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-138" data-mp="271dzbktfd2an">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-139" data-mp="26z9yjbqtojel">
                Team
              </h2>
              <div className={`relative ${!isTeamExpanded && 'max-h-[60vh] overflow-hidden'}`} data-id="element-140" data-mp="1x5aw0bmu6xm4">
                <div className="flex flex-col lg:flex-row gap-12" data-id="element-141" data-mp="8juavnl9i2jr">
                  <div className="lg:w-1/2" data-id="element-142" data-mp="8ln86c9zjaf3">
                    <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-143" data-mp="ckmikcehjzdx">
                      <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-144" data-mp="hkierpgxymix">
                        Crew
                      </h3>
                      <div className="space-y-4" data-id="element-145" data-mp="mitnfwvi2qzk">
                        {[{
                        position: 'Director',
                        name: 'Antoine Bellanger'
                      }, {
                        position: 'Producers',
                        name: 'Dmitry Repin, Joost Breeksema, Mack Kennedy'
                      }, {
                        position: 'Camera',
                        name: 'Martina Trepczyk (Girona, Amsterdam, Leiden, Vienna), Charles Antoine Bellanger, Istvàn Gábor Takács (Haarlem)'
                      }, {
                        position: 'Editor',
                        name: 'Antoine Bellanger'
                      }, {
                        position: 'Score',
                        name: 'Hariton'
                      }, {
                        position: 'Sound/Assistant Camera',
                        name: 'Rian Davidson (Girona, Amsterdam, Leiden)'
                      }, {
                        position: 'Associate Producer/International Sales',
                        name: 'Olga Tchekhoff'
                      }, {
                        position: 'Assistant Editor',
                        name: 'Lola Norymberg'
                      }, {
                        position: 'Voice Artists',
                        name: 'Scarlett Butler, Charles Gibbons, Nguyen Harrington, Eleanor Melinn, Paul Woodson, Michael Workman, Petar Zakavica'
                      }, {
                        position: 'Sound Mixer',
                        name: 'Petros Drossos'
                      }, {
                        position: 'Color Correction',
                        name: 'Florian Jarry'
                      }, {
                        position: 'Shooting Locations',
                        name: 'Spain, Austria, The Netherlands'
                      }].map((item, index) => <div key={index} className="border-b border-white/10 pb-4" data-id="element-146" data-mp="1ocxaymhhf3f5" data-mpi={index}>
                            <div className="font-medium text-purple-200" data-id="element-147" data-mp="1xdvbguspossz">
                              {item.position}
                            </div>
                            <div className="text-white/90" data-id="element-148" data-mp="v20k6cl9xnp6">{item.name}</div>
                          </div>)}
                      </div>
                    </div>
                  </div>
                  <div className="lg:w-1/2" data-id="element-149" data-mp="13zubta83ft60">
                    <div className="backdrop-blur-sm bg-black/20 p-6 rounded-lg" data-id="element-150" data-mp="18sdq69elusbv">
                      <h3 className="text-2xl font-display font-bold mb-6 text-purple-300" data-id="element-151" data-mp="1dqxc49t78448">
                        Interviewees
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-152" data-mp="1iogqd9pwcgw6">
                        {['Adnan', 'Alejandro Carbó', 'Alexander Ehrmann', 'Andrew McLeod', 'Ben Sheinwald', 'Chloé Pronovost-Morgan', 'Christopher Timmermann', 'Daan Keiman', 'David Dupuis', 'Grace Blest Hopley', 'Gül Dölen', 'Ivan Jagdish', 'Joost Breeksema', 'Nicholas Canby', 'Nicholas Langlitz', 'Karin Silenzi di Stagni', 'Leor Roseman', 'Indri Tulusan', 'Tamara Slock', 'Tijmen Bostoen', 'Wim van den Brink'].map((name, index) => <div key={index} className="border-b border-white/10 pb-2 text-white/90" data-id="element-153" data-mp="3vveyp8z9hggp" data-mpi={index}>
                            {name}
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                {!isTeamExpanded && <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/20 to-transparent" data-id="element-154" data-mp="788jzpamr58w" />}
              </div>
              <div className="relative z-20 w-full bg-black/20 backdrop-blur-sm py-8" data-id="element-155" data-mp="3uf1759m8kv6w">
                <div className="max-w-7xl mx-auto px-8" data-id="element-156" data-mp="2afhb68jctdd">
                  <button onClick={() => setIsTeamExpanded(!isTeamExpanded)} className="mx-auto block text-purple-400 hover:text-purple-300 transition-colors" data-id="element-157" data-mp="2aynjpotptbk">
                    {isTeamExpanded ? 'Show Less' : 'Show More'}
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section id="contact" className="min-h-screen w-full bg-black text-white flex items-center relative overflow-hidden" data-id="element-158" data-mp="lx4rnl8ryg8z">
            <div className="absolute inset-0" data-id="element-159" data-mp="36pgeu0470lky">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/57e9d2ef-278e-49ae-8999-b4cd111ef88c/EEM-6th-screen-1920.jpg" alt="Contact section background" className="w-full h-full object-cover" data-id="element-160" data-mp="36q8afaxsijb8" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-161" data-mp="385azg5we6mp6" />
            </div>
            <div className="max-w-7xl mx-auto px-8 py-24 relative z-10 w-full" data-id="element-162" data-mp="3356iyfvhhryy">
              <h2 className="font-display text-4xl md:text-5xl font-bold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-163" data-mp="2fhoo2bgxadrr">
                Contact
              </h2>
              <div className="backdrop-blur-sm bg-black/20 p-8 rounded-lg max-w-2xl" data-id="element-164" data-mp="2p8jb3i1zthe9">
                <div className="space-y-8" data-id="element-165" data-mp="2kex7efdt4nul">
                  <div className="border-l-4 border-purple-400/50 pl-6 py-2" data-id="element-166" data-mp="1wqnnjj05ma63">
                    <h3 className="text-xl font-display font-bold mb-2 text-purple-300" data-id="element-167" data-mp="1wokne65af0nn">
                      Distribution
                    </h3>
                    <p className="text-white/90" data-id="element-168" data-mp="3rt0v3bu1itbl">
                      Please contact Jambica DOCS:{' '}
                      <a href="mailto:juan@jambikadocs.com" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-169" data-mp="mhm827rldfx">
                        juan@jambikadocs.com
                      </a>
                    </p>
                  </div>
                  <div className="border-l-4 border-purple-400/50 pl-6 py-2" data-id="element-170" data-mp="38wsoo4pakcep">
                    <h3 className="text-xl font-display font-bold mb-2 text-purple-300" data-id="element-171" data-mp="3dvcbe7bpls84">
                      Events, Screenings, & Partnerships
                    </h3>
                    <p className="text-white/90" data-id="element-172" data-mp="3mvihv98zprxs">
                      Please contact the producers at:{' '}
                      <a href="mailto:EEMdocumentary@gmail.com" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-173" data-mp="x6gjakcppf6q">
                        EEMdocumentary@gmail.com
                      </a>
                    </p>
                  </div>
                  <div className="border-l-4 border-purple-400/50 pl-6 py-2" data-id="element-174" data-mp="17ax0bh1xh2c4">
                    <h3 className="text-xl font-display font-bold mb-2 text-purple-300" data-id="element-175" data-mp="12i3wcvea9y13">
                      Social Media
                    </h3>
                    <div className="space-y-3" data-id="element-176" data-mp="yf7ej6wki5y7">
                      <p className="text-white/90" data-id="element-177" data-mp="tigzmmwi1ged">
                        <span className="text-white/70" data-id="element-178" data-mp="tfuka13d9wll">X: </span>
                        <a href="https://x.com/eem_documentary" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-179" data-mp="ohj99n1c5g1s">
                          @EEM_documentary
                        </a>
                      </p>
                      <p className="text-white/90" data-id="element-180" data-mp="29wysolmpn45b">
                        <span className="text-white/70" data-id="element-181" data-mp="2t5gv5vkfz0d0">Instagram: </span>
                        <a href="https://instagram.com/eem_documentary/" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-182" data-mp="2t7kvk3j4th8j">
                          @EEM_documentary
                        </a>
                      </p>
                      <p className="text-white/90" data-id="element-183" data-mp="2egax4axcbg6p">
                        <span className="text-white/70" data-id="element-184" data-mp="2eh3tqj2l4pb4">YouTube: </span>
                        <a href="https://youtube.com/@EverythingElseMatters" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300 transition-colors" data-id="element-185" data-mp="20h2sv3mblhvn">
                          @EverythingElseMatters
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Router>;
}
export default App;